// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1qFcH","colMin":"styles_colMin__2Gnuy","colCheckbox":"styles_colCheckbox__1GRVn"};